import { compose, applyMiddleware } from "@reduxjs/toolkit";
import { createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";
import { rootReducer } from "../reducers";
import { rootSaga } from "../sagas";
import { wishlistsApi, spreedlyCredentialsApiMiddleware } from "@capone/common";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
  }
}
const composeEnhancers =
  (process.env.NODE_ENV !== "production" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    })) ||
  compose;

//REDUX SAGA middleware
export const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunk, sagaMiddleware, wishlistsApi.middleware, spreedlyCredentialsApiMiddleware)
  )
);

sagaMiddleware.run(rootSaga);
